'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputStyles = undefined;
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _spinner = require('../../../assets/spinner.svg');
var _spinner2 = _interopRequireDefault(_spinner);
var _sharedStyles = require('../shared-styles');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var inputStyles = exports.inputStyles = function inputStyles(props) {
  var theme = props.theme;
  var validationStyles = function validationStyles() {
    if (typeof props.valid !== 'undefined') {
      return props.valid ? (0, _sharedStyles.validStyles)(theme) : (0, _sharedStyles.invalidStyles)(theme);
    }
  };
  var validatingSpinner = function validatingSpinner() {
    if (props.validating) {
      return {
        backgroundImage: 'url(' + _spinner2.default + ')',
        backgroundPosition: 'right center',
        backgroundRepeat: 'no-repeat'
      };
    }
  };
  var readOnly = function readOnly() {
    if (props.readOnly) {
      return {
        background: 'unset',
        border: 'unset',
        padding: 'unset',
        color: 'unset'
      };
    }
  };
  return Object.assign({
    minWidth: 0,
    // This is to allow firefox, flex and input groups like the reg lookup to play nicely together. Otherwise, firefox won't shrink inputs correctly and instead lets them overflow.
    letterSpacing: 'normal',
    textAlign: 'start',
    textIndent: 0,
    textRendering: 'auto',
    textShadow: 'none',
    textTransform: 'none',
    wordSpacing: 'normal'
  }, (0, _sharedStyles.formControl)(theme), validationStyles(), validatingSpinner(), readOnly());
};
exports.default = (0, _glamorous2.default)('input', {
  forwardProps: ['autocomplete']
})(inputStyles);